import { ButtonBase } from '@mui/material';
import React from 'react';
import {
  FaCircleCheckLightSvgIcon,
  FaCircleDashedLightSvgIcon,
} from '../../../assets/icons/svgs';
import { UserLocation } from '../../../redux/user/userSlice';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { useTranslation } from 'react-i18next';
import { nospenStyles } from '../../../theme/styles';
import { MIN_LOCATION_ITEM_HEIGHT } from '../styles';
import LocationItemTypeIcon from '../LocationItemTypeIcon';
import LocationItemContent from '../LocationItemContent';

interface LocationRemoveSelectItemProps {
  location: UserLocation;
  isSelected: boolean;
  toggleSelection: (id: string) => void;
  isLastItem?: boolean;
}

const LocationRemoveSelectItem: React.FC<LocationRemoveSelectItemProps> = ({
  location,
  isSelected,
  toggleSelection,
  isLastItem,
}) => {
  const { t, i18n } = useTranslation();
  const SelectionIndicator = () => {
    if (location.default) {
      return (
        <div
          style={{
            color: colors.textGreyMedium,
            fontSize: fontSize.md,
          }}
        >
          {t('common.default')}
        </div>
      );
    }

    if (isSelected) {
      return (
        <FaCircleCheckLightSvgIcon
          size={fontSize['3xl']}
          style={{ color: colors.red }}
        />
      );
    }

    return (
      <FaCircleDashedLightSvgIcon
        size={fontSize['3xl']}
        style={{ color: colors.backgroundSuperLight }}
      />
    );
  };

  return (
    <ButtonBase
      onClick={() => toggleSelection(location.id)}
      disabled={location.default}
      style={{
        paddingTop: spacing.medium,
        paddingBottom: spacing.medium,
        background: 'transparent',
        display: 'block',
        width: '100%',
        textAlign: 'left',
        minHeight: MIN_LOCATION_ITEM_HEIGHT,
        borderBottom: isLastItem
          ? 'none'
          : `1px solid ${colors.backgroundSuperLight}`,
        opacity: location.default ? nospenStyles.inactiveOpacity : 1,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'inline-block',
              marginRight: spacing.medium,
            }}
          >
            <LocationItemTypeIcon
              containerStyle={{
                ...(isSelected ? { backgroundColor: colors.red } : {}),
              }}
              location={location}
              isSelected={isSelected}
            />
          </div>
          <div
            style={{
              display: 'inline-block',
            }}
          >
            <LocationItemContent
              selectedColor={colors.red}
              location={location}
              isSelected={isSelected}
            />
          </div>
        </div>

        <div
          style={{
            display: 'inline-block',
          }}
        >
          <SelectionIndicator />
        </div>
      </div>
    </ButtonBase>
  );
};

export default LocationRemoveSelectItem;
